/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2022, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { createSlice } from '@reduxjs/toolkit';

import { parseOpenAPIExtension } from './actions';
import { instancesAdapter } from './adapter';

// Slice + Reducer
const slice = createSlice({
  name: 'parsedOpenAPIExtensions',
  initialState: {
    instances: instancesAdapter.getInitialState()
  },
  reducers: {
    removeParsedOpenAPIExtension: (state, action) => {
      instancesAdapter.removeOne(state.instances, action.payload);
    },
    resetParsedOpenAPIExtensions: state => {
      instancesAdapter.removeAll(state.instances);
    }
  },
  extraReducers: builder => {
    builder.addCase(parseOpenAPIExtension.fulfilled, (state, action) => {
      if (typeof action === 'object' && action.payload) {
        instancesAdapter.upsertOne(state.instances, action.payload);
      }
    });
  }
});

export const { removeParsedOpenAPIExtension, resetParsedOpenAPIExtensions } =
  slice.actions;

export default slice.reducer;
